var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('BTabs',{attrs:{"id":"pipeline-tabs","active":""}},[_c('SalesFunnelStages',{attrs:{"can":_vm.can},on:{"click":_vm.handleTabChange}}),_vm._v(" "),_c('SalesFunnelOtherSettings',{on:{"click":_vm.handleTabChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }